module.exports = __webpack_public_path__ + "assets/images/amira_celebration_alert_modal_open.c8731dfe9b1180d8047ad64515abe170.svg";